import { useContext } from 'react';
import { EnvironmentContext } from '../contexts/EnvironmentContext';

// A custom hook allows us to test better.
export const useEnvironmentContext = () => useContext(EnvironmentContext);

export default useEnvironmentContext;
